import type { ExamFormTestProm, Question } from "@rmh/defs";
import { Prom, TestKey } from "@rmh/defs";
import { defaults, PROM_TEST_TITLE_PREFIX } from "./defaults";
import { quickdashEn } from "./en/quickdash";
import { quickdashEs } from "./es/quickdash";

const createProm = (locale: string): ExamFormTestProm => {
  const translations = locale === "es" ? quickdashEs : quickdashEn;

  return {
    promName: "Quickdash",
    promBodyRegion: Prom.Quickdash,
    redToGreen: false,
    startAt: 1,
    updatedAt: new Date().toISOString(),
    testKey: TestKey.Quickdash,
    testTitle: `${PROM_TEST_TITLE_PREFIX} - Quickdash`,
    questions: translations.questions,
  };
};

export const quickdashProm = {
  ...defaults,
  examFormTests: [
    {
      __typename: "ExamFormTestProm",
      ...createProm("en"), // Default to English
    },
  ],
};

export const getQuickdashProm = (locale: string = "en") => {
  return {
    ...defaults,
    examFormTests: [
      {
        __typename: "ExamFormTestProm",
        ...createProm(locale),
      },
    ],
  };
};

export const quickdashCalculations = (questions: Question[]) => {
  const sum = questions.reduce((reducer, question) => {
    const score = question.userAnswer ?? 0;

    return score + reducer;
  }, 0);

  return (sum / questions.length - 1) * 25;
};
